<ng-container *ngIf="!versionMissmatch">
  <ng-container *ngIf="isAuthenticated(); else unauthenticated">
    <app-side-nav-outer-toolbar title="{{appInfo.application}}" class="dx-card">
      <router-outlet></router-outlet>
    </app-side-nav-outer-toolbar>
  </ng-container>
  
  <!-- Login logic -->
  <ng-template #unauthenticated class="dx-card">
    <app-unauthenticated-content></app-unauthenticated-content>
  </ng-template>
  
  <!-- Loading for full page -->
  <dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#employee' }"
    [visible]="(loadingService.loading$| async) ?? false"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
  ></dx-load-panel>
  
  <!-- Installation prompt for Windows/Android -->
  <dx-popup
    [(visible)]="isInstallPromptVisible"
    [width]="380"
    [height]="350"
    [showTitle]="true"
    [title]="'install-application' | translateWithFallback"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
  >
    <div *dxTemplate="let data of 'content'">
      <div style="text-align: center;">
        <img src="assets/icons/logo.png" alt="App Icon" style="width: 100px; height: 100px; margin-bottom: 10px;">
        <p>{{'install-app-question' | translateWithFallback}}</p>
  
        <dx-check-box
          text="Don't show again"
          (onValueChanged)="dontShowInstallPrompt($event)"
          style="margin-bottom: 20px;"
        ></dx-check-box>
  
        <div>
          <dx-button
            [text]="'cancel' | translateWithFallback"
            type="danger"
            (onClick)="isInstallPromptVisible = false"
            style="margin-right: 20px;"
          ></dx-button>
          <dx-button
            [text]="'install' | translateWithFallback"
            type="success"
            (onClick)="installApp()"
          ></dx-button>
        </div>
      </div>
    </div>
  </dx-popup>
  
  <!-- Installation prompt for MAC/IOS -->
  <dx-popup
    [(visible)]="isInstallPromptVisibleIOS"
    [width]="380"
    [height]="420"
    [showTitle]="true"
    [title]="'install-application' | translateWithFallback"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    >
    <div *dxTemplate="let data of 'content'">
      <div style="text-align: center;">
        <img src="assets/icons/logo.png" alt="App Icon" style="width: 80px; height: 80px; margin-bottom: 10px;">
        <p>{{'install-app-question' | translateWithFallback}}</p>
        <ul style="text-align: left;">
          <li><strong>{{'step' | translateWithFallback}} 1</strong> {{'tap-share-icon' | translateWithFallback}} </li>
          <li><strong>{{'step' | translateWithFallback}} 2</strong> {{'scroll-down-and-tap' | translateWithFallback}} <strong>"{{'add-to-home-screen' | translateWithFallback}}"</strong></li>
          <li><strong>{{'step' | translateWithFallback}} 3</strong> {{'you-will-be-propted' | translateWithFallback}} <strong>"{{'add' | translateWithFallback}}"</strong> {{'in-top-right-corner' | translateWithFallback}}.</li>
        </ul>
        <dx-check-box
          [text]="'do-not-show-again' | translateWithFallback"
          (onValueChanged)="dontShowInstallPrompt($event)"
          style="margin-right: 20px;"
        ></dx-check-box>
        <dx-button
          [text]="'cancel' | translateWithFallback"
          type="default"
          (onClick)="closeInstallPromptIOS()"
          style="margin-right: 20px;"
        ></dx-button>
      </div>
    </div>
  </dx-popup>
  
  <!-- Offline pront detector -->
  <dx-popup
    [(visible)]="isOffline"
    [width]="480"
    [height]="480"
    [showTitle]="false"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    >
    <img src="assets/img/offline.png" alt="App Icon" style="width: 70%; height: 70%; margin: 0 auto; display: block;">
    <div style="text-align: center; margin-top: 10px;">
      <h4>{{'you-are-offline' | translateWithFallback}}</h4>
      <p>{{'app-can-not-work-offline' | translateWithFallback}}</p>
      <p>{{'please-check-your-internet-connection' | translateWithFallback}}</p>
    </div>
  </dx-popup>
</ng-container>

<ng-container *ngIf="versionMissmatch">
  <p class="unexpected-version-info"> {{'unexpected-server-version' | translateWithFallback}} <br> {{'current-is' | translateWithFallback}} {{backendVersion}} {{'and-expected' | translateWithFallback}}  {{expectedVersion}} <br> {{'application-version-is' | translateWithFallback}}  {{feVersion}}</p>
</ng-container>